<sc-flex vertical fitHeight stretchContent>

  <div class="  no-field-space timeframe-matching    selection" [formGroup]="strcutureSelectionFormGroup">

    <sc-flex>
      <mat-form-field appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.timeframe-matching.from-date"></sc-dictionary-label>
        </mat-label>
        <input matInput formControlName="dateFrom" [matDatepicker]="picker1" type="date-local">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
      <sc-content-spacer></sc-content-spacer>
      <mat-form-field appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.timeframe-matching.to-date"></sc-dictionary-label>
        </mat-label>
        <input matInput formControlName="dateUntil" [matDatepicker]="picker2" type="date-local">
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
      <sc-content-spacer></sc-content-spacer>
      <mat-form-field appearance="fill" class="structure-selection">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.timeframe-usage.structure.node"></sc-dictionary-label>
        </mat-label>
        <mat-select name="structureNode" formControlName="structureNode">
          @for (o of structureNodes; track o) {
            <mat-option [value]="o">
              @if (o.stationGroupId == null && o.stationSetId != null) {
                &nbsp;&nbsp;
              }
              {{o.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <sc-content-spacer></sc-content-spacer>
      <sc-button dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.action-update-now" primary (click)="updateData()" [disabled]="!strcutureSelectionFormGroup.valid"></sc-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-button dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.export" primary (click)="createExcel()" [disabled]="isCreateDisabled()"></sc-button>
    </sc-flex>
  </div>

  <sc-content-spacer vertical></sc-content-spacer>

  <div class="carrier-filter">
    @if (selectedCarrier) {
      <span class="item action" (click)="resetCarrierSelection()">
        <sc-icon iconClass="fa-chevron-left"></sc-icon>
      </span>
    }
    {{selectedCarrier}}
  </div>

  @if (selectedCarrier) {
    <sc-content-spacer vertical></sc-content-spacer>
  }

  <div class="results-summary">
    <sc-flex stretchContent>
      <div class="title">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.summary"></sc-dictionary-label>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="summary-value">
        <div class="caption">
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.transports"></sc-dictionary-label>
        </div>
        <div class="value-count">{{sumRow?.totalTransports}}</div>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="summary-value">
        <div class="caption">
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.withTimeSlot"></sc-dictionary-label>
        </div>
        <div class="value-count">{{sumRow?.withTimeslotBooking}}</div>
        <div class="value-percentage">{{sumRow?.percentageWithTimeslotBooking | number: '1.1-1'}} %</div>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="summary-value">
        <div class="caption">
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.early"></sc-dictionary-label>
        </div>
        <div class="value-count">{{sumRow?.countEarly}}</div>
        <div class="value-percentage">{{sumRow?.percentageEarly | number: '1.1-1'}} %</div>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="summary-value">
        <div class="caption">
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.inTime"></sc-dictionary-label>
        </div>
        <div class="value-count">{{sumRow?.countInTime}}</div>
        <div class="value-percentage">{{sumRow?.percentageInTime | number: '1.1-1'}} %</div>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="summary-value">
        <div class="caption">
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.delayed"></sc-dictionary-label>
        </div>
        <div class="value-count">{{sumRow?.countDelayed}}</div>
        <div class="value-percentage">{{sumRow?.percentageDelayed | number: '1.1-1'}} %</div>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="summary-value">
        <div class="caption">
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.late"></sc-dictionary-label>
        </div>
        <div class="value-count">{{sumRow?.countLate}}</div>
        <div class="value-percentage">{{sumRow?.percentageLate | number: '1.1-1'}} %</div>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="summary-value">
        <div class="caption">
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.notArrived"></sc-dictionary-label>
        </div>
        <div class="value-count">{{sumRow?.countNotArrived}}</div>
        <div class="value-percentage">{{sumRow?.percentageNotArrived | number: '1.1-1'}} %</div>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="summary-value">
        <div class="caption">
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.notYetArrived"></sc-dictionary-label>
        </div>
        <div class="value-count">{{sumRow?.countNotYetArrived}}</div>
        <div class="value-percentage">{{sumRow?.percentageNotYetArrived | number: '1.1-1'}} %</div>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="summary-value">
        <div class="caption">
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.other"></sc-dictionary-label>
        </div>
        <div class="value-count">{{sumRow?.countOther}}</div>
        <div class="value-percentage">{{sumRow?.percentageOther | number: '1.1-1'}} %</div>
      </div>
    </sc-flex>
  </div>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex-fitting-content vertical>
    <sc-content-area fitHeight>
      <sc-scroll-pane>

        <table mat-table [dataSource]="dataSource">

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.table.date"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let sumRow"> {{sumRow.date}} </td>
          </ng-container>

          <ng-container matColumnDef="carrier">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.carrier"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let sumRow" class="action" (click)="setSelectedCarrier(sumRow.carrier)">
            {{sumRow.carrier}} </td>
          </ng-container>

          <ng-container matColumnDef="total-transports">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.transports"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let sumRow">
              <div class="cell-content">
                <div class="value-count">{{sumRow.totalTransports}}</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="with-timeslot-booking">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.withTimeSlot"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let sumRow">
              <div class="cell-content">
                <div class="value-count">{{sumRow.withTimeslotBooking}}</div>
                <div class="value-percentage">{{sumRow.percentageWithTimeslotBooking | number: '1.1-1'}} %</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="early">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.early"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let sumRow">
              <div class="cell-content">
                <div class="value-count">{{sumRow.countEarly}}</div>
                <div class="value-percentage">{{sumRow.percentageEarly | number: '1.1-1'}} %</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="in-time">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.inTime"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let sumRow">
              <div class="cell-content">
                <div class="value-count">{{sumRow.countInTime}}</div>
                <div class="value-percentage">{{sumRow.percentageInTime | number: '1.1-1'}} %</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="delayed">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.delayed"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let sumRow">
              <div class="cell-content">
                <div class="value-count">{{sumRow.countDelayed}}</div>
                <div class="value-percentage">{{sumRow.percentageDelayed | number: '1.1-1'}} %</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="late">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.late"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let sumRow">
              <div class="cell-content">
                <div class="value-count">{{sumRow.countLate}}</div>
                <div class="value-percentage">{{sumRow.percentageLate | number: '1.1-1'}} %</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="not-arrived">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.notArrived"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let sumRow">
              <div class="cell-content">
                <div class="value-count">{{sumRow.countNotArrived}}</div>
                <div class="value-percentage">{{sumRow.percentageNotArrived | number: '1.1-1'}} %</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="not-yet-arrived">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.notYetArrived"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let sumRow">
              <div class="cell-content">
                <div class="value-count">{{sumRow.countNotYetArrived}}</div>
                <div class="value-percentage">{{sumRow.percentageNotYetArrived | number: '1.1-1'}} %</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="other">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.timeframe-matching.other"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let sumRow">
              <div class="cell-content">
                <div class="value-count">{{sumRow.countOther}}</div>
                <div class="value-percentage">{{sumRow.percentageOther | number: '1.1-1'}} %</div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
          <tr mat-row *matRowDef="let transport; columns: columnsToDisplay"></tr>
        </table>

      </sc-scroll-pane>
    </sc-content-area>
  </sc-flex-fitting-content>

</sc-flex>
